export const NUMBER_BACKGROUND_COLOR = 'white';
export const NUMBER_COLOR = 'black';
export const STROKE_WIDTH = '1.5';

export const HIGHLIGHT_NUMBER_BACKGROUND_COLOR = '#a4d7e1';
export const HIGHLIGHT_NUMBER_COLOR = 'black';
export const HIGHLIGHT_STROKE_WIDTH = '4';

export const CONNECTION_PATH_DOM_SELECTOR = 'path';
